import FilterBar from 'components/common/FilterBar';
import React from 'react';
import { useFilterData } from 'routes/Transactions/components/SearchAndFilterBar/Filter/hooks';

import { FilterContainerStyled } from './styled';

const ClientSpecificFilters: React.FC = () => {
  const { ownerShipFilterBarOptions, locationFilterBarOptions } = useFilterData('appointment');
  return (
    <>
      <FilterContainerStyled className='mt-4 sm:mt-0 sm:ml-4' style={{ width: 300, maxWidth: '33%' }}>
        <FilterBar options={ownerShipFilterBarOptions} notSpecifiedValueLabel='By Ownership: All' name='onlyMine' />
      </FilterContainerStyled>
      <FilterContainerStyled className='mt-4 sm:mt-0 sm:ml-4' style={{ width: 300, maxWidth: '33%' }}>
        <FilterBar options={locationFilterBarOptions} notSpecifiedValueLabel='By Locations: All' name='locationIds' />
      </FilterContainerStyled>
    </>
  );
};

export default React.memo(ClientSpecificFilters);
